<template>
  <v-app>
    <v-app-bar app color="white">
      <h1 class="emove--text w-100 text-center">EMOVE</h1>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <v-row dense :key="order.id" class="mb-15">
          <template v-if="step == 1">
            <v-col cols="12">
              <BookingCustomerInfo
                :key="`customer_info_${order.id}`"
                :info="order"
                :channels="channels"
                :countries="countries"
                :summary="summary"
                :is-show-all="false"
                ref="customerInfoRef"
                @onUpdate="onUpdate"
                @onDocumentRead="onDocumentRead"
              />
            </v-col>
            <v-col cols="12">
              <BookingDelivery
                :key="`booking_delivery_${order.id}`"
                :info="order"
                :branches="branches"
                :services="services"
                :summary="summary"
                ref="itemRef"
                @onUpdate="onUpdate"
              />
            </v-col>
            <v-col cols="12">
              <BookingItems
                :key="`item_${order.id}`"
                :info="order"
                :services="services"
                :assets="assets"
                :summary="summary"
                ref="itemRef"
                @onUpdate="onUpdate"
              />
            </v-col>
            <v-col>
              <v-card class="card-custom-shadow mb-2">
                <v-card-text class="fs-12">
                  <div class="d-flex align-start black--text">
                    <v-checkbox
                      v-model="isAllowPolicy"
                      :value="1"
                      hide-details
                      class="mt-0 pt-0"
                      readonly
                      @click="showPolicyDialog"
                    >
                    </v-checkbox>
                    <div>
                      I agree with EMOVE's
                      <span
                        class="primary--text text-decoration-underline"
                        @click="showPolicyDialog"
                      >
                        policy</span
                      >.
                      <br />
                      Tôi đồng ý với
                      <span
                        class="primary--text text-decoration-underline"
                        @click="showPolicyDialog"
                      >
                        chính sách
                      </span>
                      của EMOVE.
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </template>
          <template v-else-if="step == 2">
            <v-col cols="12">
              <BookingPayment
                :key="`payment_${order.id}`"
                :info="order"
                :summary="summary"
                ref="paymentRef"
                @onUpdate="onUpdate"
                @goBack="goBack"
              />
            </v-col>
          </template>
          <template v-else-if="step == 3">
            <v-col cols="12">
              <BookingSuccess
                :info="order"
                :summary="summary"
                type="partner"
                ref="successRef"
                @onUpdate="onUpdate"
              />
            </v-col>
          </template>
        </v-row>
        <div class="fixed-bottom-block">
          <v-row dense>
            <template v-if="step == 1">
              <v-col cols="6">
                <v-btn color="error" small block @click="resetAll">
                  {{ order.id ? $t("Cancel [Hủy đơn]") : $t("Redo [Làm lại]") }}
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  color="success"
                  small
                  block
                  :disabled="!documentRead || !isAllowPolicy"
                  @click="saveProcessing"
                >
                  {{ $t("Next [Tiếp]") }}
                </v-btn>
              </v-col>
            </template>
            <template v-else-if="step == 2">
              <v-col cols="12">
                <v-btn color="warning" small block @click="goBack">
                  {{ $t("Back [Quay lại]") }}
                </v-btn>
              </v-col>
            </template>
            <template v-else-if="step == 3">
              <v-col cols="12">
                <v-btn
                  color="purple"
                  class="white--text"
                  small
                  block
                  @click="pageReload"
                >
                  {{ $t("New order [Thêm yêu cầu mới]") }}
                </v-btn>
              </v-col>
            </template>
          </v-row>
        </div>
      </v-container>

      <v-dialog v-model="dialogPolicy" persistent max-width="640px">
        <BookingPolicy
          v-if="dialogPolicy"
          @close="hidePolicyDialog"
          @confirm="confirmPolicy"
          @cancel="cancelDialog"
        />
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
import { httpClient } from "@/libs/http";
import { httpNoLoading } from "@/libs/httpNoLoading";
import { debounce } from "lodash";
import { ORDER_STATUS } from "@/libs/const";

export default {
  name: "Booking",
  components: {
    BookingCustomerInfo: () => import("@/components/rent/BookingCustomerInfo"),
    BookingDelivery: () => import("@/components/rent/BookingDelivery"),
    BookingItems: () => import("@/components/rent/BookingItems"),
    BookingPayment: () => import("@/components/rent/BookingPayment"),
    BookingSuccess: () => import("@/components/rent/BookingSuccess"),
    BookingPolicy: () => import("@/components/rent/BookingPolicy"),
  },
  data: () => ({
    order: {
      id: "",
    },
    branches: [],
    channels: [],
    countries: [],
    services: [],
    vouchers: [],
    assets: [],
    deliveryAddress: [],
    step: 1,
    me: {},
    isLoading: false,
    documentRead: false,
    orderInterval: 0,
    tracking: null,
    isAllowPolicy: 0,
    dialogPolicy: false,
  }),
  computed: {
    selectedService() {
      if (
        !this.order.rent_day ||
        !this.order.id_asset ||
        !this.order.delivery_id_city
      ) {
        return [];
      }

      return [...this.services].find(
        (s) =>
          s.id_asset == this.order.id_asset &&
          s.id_city == this.order.delivery_id_city &&
          s.from_day <= this.order.rent_day &&
          s.to_day >= this.order.rent_day
      );
    },
    summary() {
      const data = {
        total_price: 0,
        id_service: 0,
      };

      if (!this.selectedService) {
        return data;
      }

      const itemAmount = this.selectedService.price * this.order.rent_day;
      data.total_price += itemAmount;
      data.id_service = this.selectedService.id;

      return data;
    },
  },
  mounted() {
    /* const { me } = window;
    this.me = { ...me }; */
    const { tracking } = this.$route.params;
    this.tracking = tracking || null;
    this.getAssets();
    this.getCountries();
    this.getChannels();
    this.getServices();
    this.getBranch();
    this.getProcessing();

    this.orderInterval = setInterval(() => {
      this.reCheckOrder();
    }, 5000);
  },
  methods: {
    showPolicyDialog() {
      this.dialogPolicy = true;
    },
    hidePolicyDialog() {
      this.dialogPolicy = false;
    },
    confirmPolicy() {
      this.isAllowPolicy = 1;
      this.hidePolicyDialog();
    },
    cancelDialog() {
      this.isAllowPolicy = 0;
      this.hidePolicyDialog();
    },
    async reCheckOrder() {
      if (!this.order || !this.order.id || this.step != 2) {
        return false;
      }

      const { data } = await httpNoLoading.post(
        "/order/v1/get-detail-booking",
        {
          tracking_id: this.order.tracking_id,
        }
      );

      if (!data || [ORDER_STATUS.DEPOSIT].includes(data.status)) {
        this.step = 3;
        localStorage.removeItem("_trid");
      } else if ([ORDER_STATUS.CANCELLED].includes(data.status)) {
        localStorage.removeItem("_trid");
        this.step = 1;
        this.order = {
          id: "",
        };
      }
    },
    onDocumentRead() {
      this.documentRead = true;
    },
    async getBranch() {
      const { data } = await httpClient.post("/me/v1/get-branch");
      this.branches = [...data];
    },
    async getProcessing() {
      const trackingId = localStorage.getItem("_trid");
      if (trackingId) {
        const { data } = await httpClient.post("/order/v1/get-detail-booking", {
          tracking_id: trackingId,
        });

        if (
          !data ||
          [ORDER_STATUS.CANCELLED, ORDER_STATUS.DEPOSIT].includes(data.status)
        ) {
          localStorage.removeItem("_trid");
          return false;
        }

        this.order = { ...data };
        if (this.order.status == ORDER_STATUS.WAIT_DEPOSIT) {
          this.step = 2;
        }
        this.onDocumentRead();
      }
    },
    async resetAll() {
      if (this.order.id) {
        const id_order = this.order.id;
        await httpClient.post("/order/v1/cancel-processing", {
          id_order,
        });
      }
      localStorage.removeItem("_trid");
      this.step = 1;
      this.order = {
        id: "",
      };
    },

    pageReload() {
      window.location.reload();
    },

    nextStep() {
      this.step++;
    },
    goBack() {
      this.step--;
    },

    onUpdate: debounce(function (order) {
      this.order = { ...this.order, ...order };
    }, 200),

    async saveProcessing() {
      if (!this.summary.id_service) {
        this.$vToastify.error(
          this.$t("No service available [Không có dịch vụ khả dụng]")
        );
        return false;
      }
      if (!this.order.start_time) {
        this.$vToastify.error(
          this.$t("Pickup time not selected [Chưa chọn thời gian nhận xe]")
        );
        return false;
      }

      try {
        const { data } = await httpClient.post(
          "/order/v1/save-processing-booking",
          {
            ...this.order,
            ...this.summary,
            tracking: this.tracking,
          }
        );
        this.order = { ...this.order, ...data };
        localStorage.setItem("_trid", this.order.tracking_id);

        this.nextStep();
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
      }
    },

    async getCountries() {
      const { data } = await httpClient.post("/common/v1/get-country");
      this.countries = [...data];
    },

    async getChannels() {
      const { data } = await httpClient.post("/common/v1/get-channel", {
        type: 2,
      });
      this.channels = [...data];
    },

    async getAssets() {
      const { data } = await httpClient.post(
        "/asset/v1/get-by-city-for-partner",
        {
          id_city: this.idCity,
        }
      );
      this.assets = [...data];
    },

    async getServices() {
      const { data } = await httpClient.post("/common/v1/get-service");
      this.services = [...data];
    },
  },
};
</script>
